import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClientProfile } from '../../../interfaces/common';
import CustomButton from "../../../components/CustomButton";
import Checkbox from "../../../components/Checkbox";

interface Props {
  profile: ClientProfile;
  save: (profile: ClientProfile) => void;
  goBack: Function
}

const StepFive: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const [coachIndustryExperiences, setCoachIndustryExperiences] = useState<Array<string>>(
    props.profile.coachIndustryExperiences
  );

  // Separate arrays for each category
  const technologyAndInnovation = [
    { name: 'executive_coaching', label: t('executive_coaching') },
    { name: 'tech_it', label: t('tech_it') },
    { name: 'telecommunications', label: t('telecommunications') },
  ];

  const financeAndProfessionalServices = [
    { name: 'energy_environment', label: t('energy_environment') },
    { name: 'finance_legal_insurance', label: t('finance_legal_insurance') },
    { name: 'education_research', label: t('education_research') },
    { name: 'media_pr', label: t('media_pr') },
    { name: 'healthcare_and_pharma', label: t('healthcare_and_pharma') },
  ];

  const industryAndManufacture = [
    { name: 'government_public_services', label: t('government_public_services') },
    { name: 'manufacturing', label: t('manufacturing') },
    { name: 'construction_real_estate', label: t('construction_real_estate') },
    { name: 'transport_logistics', label: t('transport_logistics') },
  ];

  const consumerGoodsAndServices = [
    { name: 'agriculture_food', label: t('agriculture_food') },
    { name: 'culture_entertainment', label: t('culture_entertainment') },
    { name: 'tourism_hospitality', label: t('tourism_hospitality') },
    { name: 'sports_fitness', label: t('sports_fitness') },
    { name: 'retail_ecommerce', label: t('retail_ecommerce') },
    { name: 'fashion', label: t('fashion') },
  ];

  // Validation
  const notValid = () => coachIndustryExperiences.length === 0;

  // Save handler
  const handleSave = () => {
    const newProfile = { ...props.profile };
    newProfile.coachIndustryExperiences = coachIndustryExperiences;
    props.save(newProfile);
  };

  // Toggle an industry experience
  const toggleExperience = (experience: string) => {
    if (coachIndustryExperiences.includes(experience)) {
      // Remove it
      const newExperiences = coachIndustryExperiences.filter(e => e !== experience);
      setCoachIndustryExperiences(newExperiences);
    } else {
      // Add it
      const newExperiences = [...coachIndustryExperiences, experience];
      setCoachIndustryExperiences(newExperiences);
    }
  };

  return (
    <div className="flex flex-col gap-6">

      <div>
        {/* Heading */}
        <div className="mt-6 z-heading2">
          {t('coach-industry-experience')}
        </div>

        {/* Subheading */}
        <div className="mt-2 text-gray-400">
          {t('choose-coach-industry-experience')}
        </div>
      </div>

      <div>
        {/* Technology and Innovation */}
        <div className="z-heading2">
          {t('technology_and_innovation')}
        </div>
        <div className="mt-2 flex flex-col gap-3">
          {technologyAndInnovation.map((item) => (
            <Checkbox
              key={item.name}
              id={item.name}
              checked={coachIndustryExperiences.includes(item.name)}
              onChange={() => toggleExperience(item.name)}
              label={item.label}
            />
          ))}
        </div>
      </div>

      <hr className="border-indigo-700" />

      <div>
        {/* Finance and Professional Services */}
        <div className="z-heading2">
          {t('finance_and_professional_services')}
        </div>
        <div className="mt-2 flex flex-col gap-3">
          {financeAndProfessionalServices.map((item) => (
            <Checkbox
              key={item.name}
              id={item.name}
              checked={coachIndustryExperiences.includes(item.name)}
              onChange={() => toggleExperience(item.name)}
              label={item.label}
            />
          ))}
        </div>
      </div>

      <hr className="border-indigo-700" />

      <div>
        {/* Industry and Manufacture */}
        <div className="z-heading2">
          {t('industry_and_manufacture')}
        </div>
        <div className="mt-2 flex flex-col gap-3">
          {industryAndManufacture.map((item) => (
            <Checkbox
              key={item.name}
              id={item.name}
              checked={coachIndustryExperiences.includes(item.name)}
              onChange={() => toggleExperience(item.name)}
              label={item.label}
            />
          ))}
        </div>
      </div>

      <hr className="border-indigo-700" />

      <div>
        {/* Consumer Goods and Services */}
        <div className="z-heading2">
          {t('consumer_goods_and_services')}
        </div>
        <div className="mt-2 flex flex-col gap-3">
          {consumerGoodsAndServices.map((item) => (
            <Checkbox
              key={item.name}
              id={item.name}
              checked={coachIndustryExperiences.includes(item.name)}
              onChange={() => toggleExperience(item.name)}
              label={item.label}
            />
          ))}
        </div>
      </div>

      <hr className="border-indigo-700" />

      {/* Button */}
      <CustomButton disabled={notValid()} className="mt-6" onClick={handleSave}>
        {t('next')}
      </CustomButton>
    </div>
  );
};

export default StepFive;
